import { mergeApis, Zodios } from "@zodios/core";

import { consumptionApi } from "@/data/api/kili/consumption/consumption-api";
import { currentUserApi } from "@/data/api/kili/current-user/current-user-api";
import { internalApi } from "@/data/api/kili/internal/internal-api";
import { passwordRecoveryApi } from "@/data/api/kili/password-recovery/password-recovery-api";
import { sectionsApi } from "@/data/api/kili/sections/sections-api";
import { securityApi } from "@/data/api/kili/security/security-api";
import { sitesApi } from "@/data/api/kili/sites/sites-api";
import { deprecatedEnv } from "@/utils/env";

const KiliApiDefinition = mergeApis({
  "/kli/voltalis-hospitality": internalApi,
  "/kli/voltalis-hospitality/consumption": consumptionApi,
  "/kli/voltalis-hospitality/current-user": currentUserApi,
  "/kli/voltalis-hospitality/password-recovery": passwordRecoveryApi,
  "/kli/voltalis-hospitality/sections": sectionsApi,
  "/kli/voltalis-hospitality/sites": sitesApi,
  "/voltalis-hospitality/security": securityApi,
});

const KiliApi = new Zodios(deprecatedEnv.VITE_KILI_BASE_URL, KiliApiDefinition, {
  axiosConfig: {
    headers: {
      VoltalisApplication: "HospitalityClient",
    },
    paramsSerializer: {
      indexes: null,
    },
    withCredentials: true,
  },
});

export default KiliApi;
